import { render, staticRenderFns } from "./APIsPage.vue?vue&type=template&id=76bfdb7e&scoped=true"
import script from "./APIsPage.vue?vue&type=script&lang=js"
export * from "./APIsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bfdb7e",
  null
  
)

export default component.exports